module.exports = __webpack_public_path__ + "static/media/hospital-user.b4ec7235.svg";